import { useCopy } from '../../../shared/lib/use-copy';
import { CheckIcon, CopyIcon } from '../../../shared/ui/icons';
import { ShortId } from '../../../shared/ui/table';

export const IdCell = ({ id, keep }: { id: string; keep?: number }) => {
  const { copied, copy } = useCopy();

  return (
    // No `group` of its own: the row is the group that `group-hover` below resolves against.
    <span className="flex min-w-0 items-center gap-2">
      <ShortId id={id} keep={keep} />
      <button
        type="button"
        aria-label="Copy the whole id"
        title="Copies the whole id, never the shortened one"
        onClick={(event) => {
          event.stopPropagation();
          void copy(id);
        }}
        onKeyDown={(event) => event.stopPropagation()}
        className="shrink-0 text-faint opacity-0 group-hover:opacity-100 focus-visible:opacity-100"
      >
        {copied ? <CheckIcon size={12} /> : <CopyIcon size={12} />}
      </button>
    </span>
  );
};
